const PREFIX = 'LOCATION_STATION/';

export const SET_LOCATION = `${PREFIX}SET_LOCATION`;
export const SET_DATE = `${PREFIX}SET_DATE`;
export const SET_EXERCISE_REST = `${PREFIX}SET_EXERCISE_REST`;

export const VIDEO_CONSOLE = `${PREFIX}VIDEO_CONSOLE`;

export const SEARCH_LOCATION_STATION = `${PREFIX}SEARCH_LOCATION_STATION`;
